export default {
  MAIN: 'main',
  EMPTY: 'empty',
};
